export default (id) => ({
    items: [],
    selected: null,
    select2: null,

    init(){
        const taggable = this.$el.getAttribute('data-taggable') === 'true';

        this.select2 = $(this.$el).select2({
            placeholder: 'Selecciona una opción',
            tags: taggable
        });

        this.select2.on('select2:select', (e) => {
            this.selected = e.params.data.id;
            this.$dispatch('selectize:change', { id, value: this.selected });
        });
    },
});
